// The trust facts, mirrored from snippets/mc-facts.liquid for the scripts that render in the browser.
// Owner: orchestrator. Keep the two files in step.
window.MC_FACTS = {
  phone: "0408 106 552",
  phoneHref: "tel:+61408106552",
  hours: "Monday to Friday, 9am to 5pm Melbourne time",
  email: "info@mattresscrafters.com.au",
  abn: "",
  warehouse: "Melbourne",
  store: "44 to 46 Altin Street, Griffith, New South Wales 2680",
  since: "1963",
  founded: "",
  refundLine: "Fewer than 1 in 100 customers ask for a refund",
  collectionFee: "$250",
  deliveryWindow: "2 to 12",
  metroLine: "Melbourne metro is the next business day",
  mtoDays: "5",
  cutoff: { enabled: false, time: "14:00", days: ["Mon", "Tue", "Wed", "Thu", "Fri"], tz: "Australia/Melbourne" },
  courier: "our courier partner",
  reviewPlatform: "Yotpo"
};
